import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, List, X } from "@phosphor-icons/react";
import { LOGO_ICON, PHONE_DISPLAY, PHONE_TEL } from "@/lib/brand";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  const navLinks = [
    { href: "#services", label: "Services" },
    { href: "#why-us", label: "Why Us" },
    { href: "#process", label: "How It Works" },
    { href: "#happy-customers", label: "Reviews" },
    { href: "#about", label: "About" },
    { href: "#quote", label: "Get a Quote" },
  ];

  return (
    <header
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/60"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
            <img
              src={LOGO_ICON}
              alt="Heavenly Home And Office"
              className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover ring-2 ring-sky-100 group-hover:ring-sky-200 transition"
            />
            <div className="hidden sm:block leading-tight">
              <div className="font-display font-bold text-slate-900 text-base md:text-lg">
                Heavenly Home &amp; Office
              </div>
              <div className="text-xs text-slate-500 -mt-0.5">Cleaning • Handyman • Home Services</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={`tel:${PHONE_TEL}`}
              className="hidden md:inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
              data-testid="header-call-button"
            >
              <Phone size={16} weight="bold" />
              {PHONE_DISPLAY}
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 inline-flex items-center justify-center rounded-full border border-slate-200 text-slate-700"
              aria-label="Toggle navigation"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={20} /> : <List size={20} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-4" data-testid="mobile-nav">
            <div className="flex flex-col gap-1 pt-2 border-t border-slate-200/60">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="px-2 py-3 text-slate-700 hover:text-slate-900 hover:bg-slate-50 rounded-lg text-sm font-medium"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={`tel:${PHONE_TEL}`}
                className="mt-2 inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-600 text-white font-semibold px-5 py-3 rounded-full justify-center"
                data-testid="mobile-call-button"
              >
                <Phone size={16} weight="bold" /> Call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
